import React, { useContext, useEffect } from 'react';
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useIsAuthenticated,
  useMsal,
} from '@azure/msal-react';
import { Container } from 'react-bootstrap';
import { Navigate, useNavigate } from 'react-router-dom';
import Layout from '../../components/layout/layout';
import { AppContext } from '../../context/appContext';
import { GET_USER_ROLES } from '../../components/helper/constant';
import UserStats from '../../components/userDashboard/userStats';

const { SUPER_USER, DEPARTMENT_HEAD, ACCOUNT_MANAGER, TALENT, TALENT_TEAM } =
  GET_USER_ROLES;

const Dashboard = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const { profile, getRole } = useContext(AppContext);
  const isAuthenticated = useIsAuthenticated();
  useEffect(() => {
    if (instance && isAuthenticated && profile) {
      const userRole = getRole();
      if (
        ![
          SUPER_USER,
          DEPARTMENT_HEAD,
          TALENT,
          ACCOUNT_MANAGER,
          TALENT_TEAM,
        ].includes(userRole)
      ) {
        navigate('/');
      }
    }
  }, [instance, isAuthenticated, profile]);

  return (
    <>
      <UnauthenticatedTemplate>
        <Navigate to="/" />
      </UnauthenticatedTemplate>
      <AuthenticatedTemplate>
        <Layout>
          <main className={`flex-grow-1 d-flex dashboard`}>
            <Container fluid className="d-flex flex-column p-0">
              <div className="pageHead d-flex justify-content-between align-items-center">
                <h1 className="title mb-0">Dashboard</h1>
              </div>
              <UserStats />
            </Container>
          </main>
        </Layout>
      </AuthenticatedTemplate>
    </>
  );
};

export default Dashboard;
